// Tiny history-API router — the app has three route shapes ('/', '/galerie/:slug',
// '/admin'), a router library would be more code than this file.
import React, { useEffect, useState } from 'react';

export function navigate(path, { replace = false } = {}) {
	if (path === window.location.pathname) return;
	window.history[replace ? 'replaceState' : 'pushState']({}, '', path);
	// pushState doesn't fire popstate — dispatch one so usePath() re-renders.
	window.dispatchEvent(new PopStateEvent('popstate'));
}

export function usePath() {
	const [path, setPath] = useState(window.location.pathname);
	useEffect(() => {
		const onPop = () => setPath(window.location.pathname);
		window.addEventListener('popstate', onPop);
		return () => window.removeEventListener('popstate', onPop);
	}, []);
	return path;
}

// Plain anchor (middle-click / cmd-click keep working) with SPA interception.
export function Link({ children, to, ...rest }) {
	const onClick = (e) => {
		if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
		e.preventDefault();
		navigate(to);
	};
	return (
		<a href={to} onClick={onClick} {...rest}>
			{children}
		</a>
	);
}
